export const GRAPH_HEADERS = {
  Authorization: 'Bearer 965502a593f79cf5de379a356fe874e6',
  'Content-Type': 'application/json'
};

export const fetcher = async (
  url: string,
  init?: RequestInit | undefined,
  shouldFormat = true
) => {
  try {
    const response = await fetch(url, {
      method: 'GET',
      mode: 'cors',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      ...init
    });
    const jsonRes = await response.json();
    return shouldFormat ? jsonRes?.data : jsonRes;
  } catch (error) {
    console.log('error', error);
  }
};

export const getRequest = async (
  url: string,
  init?: RequestInit | undefined
) => {
  try {
    const response = await fetch(url, {
      method: 'GET',
      mode: 'cors',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      ...init
    });
    const res = await response.json();
    return res;
  } catch (error) {
    console.error('error', error);
  }
};
